export enum AuctionDataType {
  STANDARD = 'standard',
  COMPARABLE = 'comparable',
  GRAPH = 'graph'
}